import { withPrefix } from "gatsby"

const applyPrefix = (url) => {
  // the following urls should not be prefixed
  const nonPrefixedURIs = ["mailto:", "tel:", "#", "/cassets"]
  return nonPrefixedURIs.some((uri) => url.startsWith(uri)) ? url : withPrefix(url)
}

export default applyPrefix
